import {Injectable, signal} from '@angular/core';
import {bannersSocialFilesPath} from "../configs/banners-social-modal-config";

@Injectable({
  providedIn: 'root'
})
export class BannerSocialFilePathStateService {
  private _pathFileState = signal<string>('');
  public pathFileState = this._pathFileState.asReadonly();

  public setPathFileState(modalKey: string): void {
    this._pathFileState.set(bannersSocialFilesPath[modalKey]);
  }

  public resetPathFileState(): void {
    this._pathFileState.set('');
  }
}
